import { render } from "./TrainForm.vue?vue&type=template&id=3da306e0&scoped=true"
import script from "./TrainForm.vue?vue&type=script&lang=js"
export * from "./TrainForm.vue?vue&type=script&lang=js"

import "./TrainForm.vue?vue&type=style&index=0&id=3da306e0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da306e0"]])

export default __exports__